import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  Output,
  EventEmitter,
  SimpleChanges,
  OnChanges,
  ViewChild,
} from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormArray,
  FormControl,
} from '@angular/forms';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import {
  debounce,
  debounceTime,
  distinctUntilChanged,
  ignoreElements,
  map,
} from 'rxjs/operators';
import { LoadingService } from 'src/app/core/services/loader.service';
import { UsersService } from '../services/users.service';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { Observable, Subject } from 'rxjs';
enum housingSituation {
  BOARDING = '1',
  CARAVAN = '2',
  OWN_HOME = '3',
  Own_Home_Mortgage = '4',
  RENTING = '5',
  WITH_PARENTS = '6',
  OTHER = '7',
}
enum eNewState {
  NSW = '854500000',
  VIC = '854500001',
  QLD = '854500002',
  WA = '854500003',
  SA = '854500004',
  TAS = '854500005',
  NT = '854500006',
  ACT = '854500007',
  OTHER = '854500008',
}
enum stateValue {
  'New South Wales' = 'NSW',
  'Victoria' = 'VIC',
  'Queensland' = 'QLD',
  'Western Australia' = 'WA',
  'South Australia' = 'SA',
  'Tasmania' = 'TAS',
  'Northern Territory' = 'NT',
  'Australian Capital Territory' = 'ACT',
  OTHER = 'OTHER',
}
enum eNewStreetType {
  '' = '100000198',
  Street = '100000000',
  Court = '100000001',
  Avenue = '100000002',
  Access = '100000003',
  Alley = '100000004',
  Alleyway = '100000005',
  Amble = '100000006',
  Anchorage = '100000007',
  Approach = '100000008',
  Arcade = '100000009',
  Artery = '100000010',
  Basin = '100000011',
  Beach = '100000012',
  Bend = '100000013',
  Block = '100000014',
  Boulevard = '100000015',
  Brace = '100000016',
  Brae = '100000017',
  Break = '100000018',
  Bridge = '100000019',
  Broadway = '100000020',
  Brow = '100000021',
  Bypass = '100000022',
  Byway = '100000023',
  Crescent = '100000024',
  Causeway = '100000025',
  Centre = '100000026',
  Centreway = '100000027',
  Chase = '100000028',
  Circle = '100000029',
  Circlet = '100000030',
  Circuit = ' 100000031',
  Circus = '100000032',
  Close = '100000033',
  Colonnade = '100000034',
  Common = '100000035',
  Concourse = '100000036',
  Copse = '100000037',
  Corner = '100000038',
  Corso = '100000039',
  Courtyard = '100000040',
  Cove = '100000041',
  Crest = '100000042',
  Cross = '100000043',
  Crossing = '100000044',
  Crossroad = '100000045',
  Crossway = '100000046',
  Cruiseway = '100000047',
  CulDeSac = '100000048',
  Cutting = '100000049',
  Drive = '100000050',
  Dale = '100000051',
  Dell = '100000052',
  Deviation = '100000053',
  Dip = '100000054',
  Distributor = '100000055',
  Driveway = '100000056',
  Edge = '100000057',
  Elbow = '100000058',
  End = '100000059',
  Entrance = '100000060',
  Esplanade = '100000061',
  Estate = '100000062',
  Expressway = '100000063',
  Fairway = '100000064',
  FireTrack = '100000065',
  Firetrail = '100000066',
  Flat = '100000067',
  Follow = '100000068',
  Footway = '100000069',
  Foreshore = '100000070',
  Formation = '100000071',
  Freeway = '100000072',
  Front = '100000073',
  Frontage = '100000074',
  Gap = '100000075',
  Garden = '100000076',
  Gardens = '100000077',
  Gate = '100000078',
  Gates = '100000079',
  Glade = '100000080',
  Glen = '100000081',
  Grange = '100000082',
  Green = '100000083',
  Ground = '100000084',
  Grove = '100000085',
  Gully = '100000086',
  Highway = '100000087',
  Heights = '100000088',
  Highroad = '100000089',
  Hill = '100000090',
  Interchange = '100000091',
  Intersection = '100000092',
  Junction = '100000093',
  Key = '100000094',
  Lane = '100000095',
  Line = '100000096',
  Landing = '100000097',
  Laneway = '100000098',
  Lees = '100000099',
  Link = '100000100',
  Little = '100000101',
  Lookout = '100000102',
  Loop = '100000103',
  Mall = '100000104',
  Meander = '100000105',
  Mew = '100000106',
  Mews = '100000107',
  Motorway = '100000108',
  Mount = '100000109',
  Nook = '100000110',
  Outlook = '100000111',
  Place = '100000112',
  Parade = '100000113',
  Park = '100000114',
  Parklands = '100000115',
  Parkway = '100000116',
  Part = '100000117',
  Pass = '100000118',
  Path = '100000119',
  Pathway = '100000120',
  Piazza = '100000121',
  Plateau = '100000122',
  Plaza = '100000123',
  Pocket = '100000124',
  Point = '100000125',
  Port = '100000126',
  Promenade = '100000127',
  Quad = '100000128',
  Quadrangle = '100000129',
  Quadrant = '100000130',
  Quay = '100000131',
  Quays = '100000132',
  Ramble = '100000133',
  Ramp = '100000134',
  Range = '100000135',
  Reach = '100000136',
  Reserve = '100000142',
  Rest = '100000143',
  Retreat = '100000144',
  Ride = '100000145',
  Ridge = '100000146',
  Ridgeway = '100000147',
  RightOfWay = '100000148',
  Ring = '100000149',
  Rise = '100000150',
  River = '100000151',
  Riverway = '100000137',
  Riviera = '100000138',
  Road = '100000139',
  Roadside = '100000140',
  Roadway = '100000141',
  Ronde = '100000152',
  Rosebowl = '100000153',
  Rotary = '100000154',
  Round = '100000155',
  Route = '100000156',
  Row = '100000157',
  Rue = '100000158',
  Run = '100000159',
  ServiceWay = '100000160',
  Siding = '100000161',
  Slope = '100000162',
  Sound = '100000163',
  Spur = '100000164',
  Square = '100000165',
  Stairs = '100000166',
  StateHighway = '100000167',
  Steps = '100000168',
  Strand = '100000169',
  Strip = '100000170',
  Subway = '100000171',
  Terrace = '100000172',
  Tarn = '100000173',
  Thoroughfare = '100000174',
  Tollway = '100000175',
  Top = '100000176',
  Tor = '100000177',
  Towers = '100000178',
  Track = '100000179',
  Trail = '100000180',
  Trailer = '100000181',
  Triangle = '100000182',
  Trunkway = '100000183',
  Turn = '100000184',
  Underpass = '100000185',
  Vale = '100000186',
  Viaduct = '100000187',
  View = '100000188',
  Villas = '100000189',
  Vista = '100000190',
  Way = '100000191',
  Wade = '100000192',
  Walk = '100000193',
  Walkway = '100000194',
  Wharf = '100000195',
  Wynd = '100000196',
  Yard = '100000197',
}

@Component({
  selector: 'app-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.scss'],
})
export class AddressComponent implements OnInit {
  selected = 'option2';
  formNumber: any;
  public token;

  formSubmitData = false;
  housSituation = housingSituation;
  @Input() parentForm: FormGroup;
  @Input()
  set formSubmit(type: boolean) {
    if (type) {
      if(this.parentForm.get('new_streettype').invalid) {
        this.new_streettype_Formatted = ''
        this.isStreetValid = false;
      }

      if(this.parentForm.get('new_country').invalid) {
        this.new_country_Formated = '';
        this.isCountryValid = false;
      }

      this.formSubmitData = type;
      this.parentForm.markAllAsTouched();
    }
  }
  @Input()
  set number(type) {
    if (type) {
      this.formNumber = type;
    }
  }
  // countryKeys = [];
  countries = [];
  streetTypeKeys = [];
  streetTypes = eNewStreetType;
  filterStreetTypekeys = [];
  filteredCountries = [];
  new_streettype_Formatted = '';
  new_country_Formated = '';
  isCountryValid = true;
  isStreetValid = true;
  stateKeys = [];
  states = eNewState;
  allAddress = [];
  // results$: Observable<any>
  searchInputData: HTMLInputElement;
  subject = new Subject();
  loading = false;
  constructor(
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private loadingService: LoadingService,
    private userService: UsersService,
    public auth: AuthenticationService
  ) {
    // this.countryKeys = Object.keys(this.countries);
    this.streetTypeKeys = Object.keys(this.streetTypes);
    this.filterStreetTypekeys = this.streetTypeKeys;
    this.stateKeys = Object.keys(this.states);
  }

  ngOnInit() {
    const findStreetType = this.streetTypeKeys.find(key => this.streetTypes[key] === this.parentForm.value.new_streettype);
    this.new_streettype_Formatted = findStreetType || '';
    if (!findStreetType) {
      this.parentForm.get('new_streettype').setValue('100000198');
    }
    this.token = this.auth.getUserAccessToken();
    this.subject
      .pipe(debounceTime(1000), distinctUntilChanged())
      .subscribe((value) => {
        this.getAddress(this.searchInputData);
      });

    this.getContries();
  }
  getFilteredStreetType(event) {
    this.filterStreetTypekeys = this.streetTypeKeys.filter((text) => text.toLowerCase().includes(event.target.value.toLowerCase()));
    this.parentForm.get('new_streettype').setValue('');
    this.isStreetValid = true;
  }
  setFilteredStreetType(event) {
    this.isStreetValid = true;
    this.new_streettype_Formatted = event.option.value;
    this.parentForm.get('new_streettype').setValue(this.streetTypes[event.option.value]);
  }

  getFilteredCountries(event) {
    this.filteredCountries = this.countries.filter((text) => text.tlx_name.toLowerCase().includes(event.target.value.toLowerCase()));
    this.parentForm.get('new_country').setValue('');
    this.isCountryValid = true;
  }

  onFormInputTypeBlur(event, type: string) {
    if (type === 'streetType') {
      if (this.streetTypeKeys.find((text) => text.toLowerCase().includes(event.target.value.toLowerCase()))) {
        this.isCountryValid = true;
        this.parentForm.get('new_streettype').setValue(this.streetTypes[event.target.value]);
      }
    } else if (type === 'countryType') {
      const text = this.countries.find((text) => text.tlx_name.toLowerCase() === event.target.value.toLowerCase());
      if (text) {
        this.isCountryValid = true;
        this.parentForm.get('new_country').setValue(text.tlx_countryid);
      }
    }

    if (this.parentForm.get('new_streettype').invalid) {
      event.target.value = ''
      this.isStreetValid = false;
    }

    if (this.parentForm.get('new_country').invalid) {
      event.target.value = '';
      this.isCountryValid = false;
    }
  }

  setFilteredCountry(event) {
    const text = this.countries.find((text) => text.tlx_countryid === event.option.value);

    if(text) {
      this.isCountryValid = true;
      this.new_country_Formated = text.tlx_name;
      this.parentForm.get('new_country').setValue(text.tlx_countryid);
    }
  }

  search(data: HTMLInputElement) {
    this.searchInputData = data;
    const searchText = data.value;

    this.subject.next(searchText);
  }

  getContries() {
    // this.loadingService.startLoading();
    this.loading = true;
    const allContries = this.auth.getAllCountries();

    if (allContries && allContries?.length) {
      this.countries = [...allContries];
      this.new_country_Formated = this.countries.find(text => text.tlx_countryid === this.parentForm.value.new_country)?.tlx_name;
      this.loading = false;
    } else {
      this.userService
        .getCountries(this.token)
        .subscribe(
          (response) => {
            this.countries = [...response.data];
            this.new_country_Formated = this.countries.find(text => text.tlx_countryid === this.parentForm.value.new_country)?.tlx_name;
            this.auth.setAllCountries([...response.data]);

            // this.loadingService.stopLoading();
            this.loading = false;
          },
          (error) => {
            //  this.loadingService.stopLoading();
            this.loading = false;
            this.auth.showSnackBarMsg('Something went wrong!.')
          }
        );
    }
  }

  getAddress(addressInput: HTMLInputElement) {
    if (addressInput.value.trim().length <= 0) {
      // console.log('Please add something to search');
      this.auth.showSnackBarMsg('Please add something to search')
      return;
    }
    // //console.log(addressInput.value.trim());
    // this.loadingService.startLoading();
    this.loading = true;
    this.userService
      .getBingAddress(this.token, addressInput.value.trim())
      .subscribe(
        (response) => {
          this.allAddress = [];
          //// console.log(response.data.value);
          response.data.value.map((address) => {
            this.allAddress.push(address.address);
          });
          // console.log(this.allAddress);
          // this.loadingService.stopLoading();
          this.loading = false;
        },
        (error) => {
          //  this.loadingService.stopLoading();
          this.loading = false;
          this.auth.showSnackBarMsg('Something went wrong!.')
        }
      );
  }
  populateAddress(address) {
    let data = {};
    data = {
      new_addresssearch: address.formattedAddress,
      tlx_streetaddress2: address.streetName,
      tlx_city: address.locality,
      new_state: eNewState[stateValue[`${address.adminDistrict}`]],
      // new_country: this.country[`${address.countryRegion}`],
      new_country: this.countries.find(text => text.tlx_name === address.countryRegion)?.tlx_countryid,
      tlx_postcode: address.postalCode,
    };
    if (address.houseNumber) {
      if (address.houseNumber.includes('/')) {
        const splitaddress = address.houseNumber.split('/');
        data = {
          ...data,
          new_streetnumber: splitaddress[1],
          tlx_street: splitaddress[0],
        };
      } else {
        data = {
          ...data,
          new_streetnumber: address.houseNumber,
        };
      }
    }
    if (address.addressLine && address.addressLine.includes('Level')) {
      const splitaddress = address.addressLine.split(',');
      data = {
        ...data,
        new_streetnumber: splitaddress[1],
        tlx_street: splitaddress[0],
      };
    }
    console.log(data);
    this.parentForm.patchValue(data);
    // console.log(this.parentForm.value);
  }
  get addressFControl() {
    return this.parentForm.controls;
  }
}
